import React from 'react';
import { connect } from 'react-redux';
import ConfidentialityRight from "./Confidentiality";
import Templates from "./Templates";

class ConfidentialTemplatesRight extends React.Component {

    render() {
        return (
            <div>
                <ConfidentialityRight />
                <Templates />
            </div>
        );
    }
}
const mapStateToProps = state => ({
    online: state.newSite.OnlineLocationrtet
})

export default connect(mapStateToProps, null)(ConfidentialTemplatesRight);





// WEBPACK FOOTER //
// ./src/components/CreateSite/Step1/ConfidentialTemplatesRight.js